/** Formats de date en français, centralisés pour rester cohérents d'un écran à l'autre. */

const DATE = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});

const TIME = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' });

const SHORT_DATE = new Intl.DateTimeFormat('fr-FR', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

/** « Mardi 1er septembre » — avec l'exposant que le français impose au premier du mois. */
export function formatSessionDate(iso: string): string {
  const date = new Date(iso);
  const formatted = DATE.format(date);
  const capitalised = formatted.charAt(0).toUpperCase() + formatted.slice(1);
  return date.getDate() === 1 ? capitalised.replace(/\b1\b/, '1er') : capitalised;
}

/**
 * La même date, découpée pour que « er » puisse être rendu en exposant.
 *
 * Le composant n'a pas à savoir manipuler des chaînes de date : il reçoit trois morceaux
 * et les pose. `sup` est vide tous les jours du mois sauf le premier.
 */
export function splitSessionDate(iso: string): { before: string; sup: string; after: string } {
  const formatted = formatSessionDate(iso);
  const index = formatted.indexOf('1er');
  if (index < 0) return { before: formatted, sup: '', after: '' };
  return {
    before: `${formatted.slice(0, index)}1`,
    sup: 'er',
    after: formatted.slice(index + 3),
  };
}

export function formatShortDate(iso: string): string {
  const date = new Date(iso);
  const formatted = SHORT_DATE.format(date);
  return date.getDate() === 1 ? formatted.replace(/\b1\b/, '1er') : formatted;
}

/** « 18h00 – 18h30 », ou seulement l'heure de début si la fin n'est pas renseignée. */
export function formatSessionTimeRange(startsAt: string, endsAt: string | null): string {
  const start = TIME.format(new Date(startsAt)).replace(':', 'h');
  if (!endsAt) return start;
  return `${start} – ${TIME.format(new Date(endsAt)).replace(':', 'h')}`;
}
